import type { CSSProperties } from "react";
import { ICON_PATHS } from "./paths";

// Réplica de Icon (star-circle-app.jsx:87-99). Primitiva compartida.
export function Icon({
  name,
  size = 22,
  stroke = 1.5,
  color = "currentColor",
  fill = "none",
  style,
}: {
  name: string;
  size?: number;
  stroke?: number;
  color?: string;
  fill?: string;
  style?: CSSProperties;
}) {
  const d = ICON_PATHS[name];
  if (!d) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
      stroke={color}
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
    >
      {d.split(" M").map((seg, i) => (
        <path key={String(i)} d={i === 0 ? seg : "M" + seg} />
      ))}
    </svg>
  );
}
